/**
 * Select control - toggle buttons for <=3 options, dropdown for >3
 * Supports optional parallel arrays for display labels and tooltip info.
 */

interface SelectControlProps {
  value: string;
  options: string[];
  optionLabels?: string[];
  optionInfo?: string[];
  color: string;
  onChange: (value: string) => void;
}

export function SelectControl({ value, options, optionLabels, optionInfo, color, onChange }: SelectControlProps) {

  if (options.length > 3) {
    // Dropdown for many options
    return (
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        title={optionInfo?.[options.indexOf(value)] ?? undefined}
        style={{
          marginLeft: 'auto',
          background: '#374151',
          color: '#e5e7eb',
          border: '1px solid #4b5563',
          width:'100%',
          borderRadius: 3,
          padding: '2px 4px',
          fontSize: 10,
          cursor: 'pointer'
        }}
        className="nodrag"
      >
        {options.map((opt, i) => (
          <option key={opt} value={opt}>{optionLabels?.[i] ?? opt}</option>
        ))}
      </select>
    );
  }

  // Toggle buttons for few options
  return (
    <div style={{
      marginLeft: 'auto',
      display: 'flex',
      gap: 2
    }}>
      {options.map((opt, i) => (
        <button
          key={opt}
          onClick={() => onChange(opt)}
          title={optionInfo?.[i] ?? undefined}
          style={{
            background: value === opt ? color : '#374151',
            color: value === opt ? 'white' : '#9ca3af',
            border: `1px solid ${value === opt ? color : '#4b5563'}`,
            borderRadius: 3,
            padding: '1px 6px',
            fontSize: 9,
            cursor: 'pointer',
            fontWeight: value === opt ? 'bold' : 'normal'
          }}
          className="nodrag"
        >
          {optionLabels?.[i] ?? opt}
        </button>
      ))}
    </div>
  );
}
